import {
    BufferAttribute,
    BufferGeometry,
    DataTexture,
    LinearFilter,
    Mesh,
    MeshBasicMaterial,
    RGBAFormat,
    UVMapping,
    UnsignedByteType,
} from 'three';

const createTexturedRectangle = ({
    height,
    imageData,
    maxU,
    maxV,
    minU,
    minV,
    order,
    sx,
    sy,
    width,
}) => {
    const texture = new DataTexture(
        imageData.data,
        imageData.width,
        imageData.height,
        RGBAFormat,
        UnsignedByteType,
        UVMapping,
    );

    texture.needsUpdate = true;
    texture.minFilter = LinearFilter;

    const material = new MeshBasicMaterial({
        map: texture,
        transparent: true,
    });

    material.depthTest = false;
    material.depthWrite = false;

    const geometry = new BufferGeometry();
    const sRectangle = new Mesh(geometry, material);

    sRectangle.renderOrder = order;

    // 4 vertices per rectangle,
    // 3 coordinates per vertex - x,y,z
    const vertices = new Float32Array(12);
    // 4 vertices per rectangle
    // 2 coordinates per vertex
    // 2 rectangles
    const uvs = new Float32Array(8);
    // 3 indices per triangle
    // 2 triangles per rectangle
    const indices = new Uint32Array(6);

    vertices[0] = sx;
    vertices[1] = sy + height;
    vertices[2] = 0;
    vertices[3] = sx + width;
    vertices[4] = sy + height;
    vertices[5] = 0;
    vertices[6] = sx;
    vertices[7] = sy;
    vertices[8] = 0;
    vertices[9] = sx + width;
    vertices[10] = sy;
    vertices[11] = 0;

    uvs[0] = minU;
    uvs[1] = maxV;

    uvs[2] = maxU;
    uvs[3] = maxV;

    uvs[4] = minU;
    uvs[5] = minV;

    uvs[6] = maxU;
    uvs[7] = minV;

    indices[0] = 2;
    indices[1] = 0;
    indices[2] = 1;
    indices[3] = 3;
    indices[4] = 2;
    indices[5] = 1;

    geometry.setAttribute('position', new BufferAttribute(vertices, 3));
    geometry.setAttribute('uv', new BufferAttribute(uvs, 2));
    geometry.setIndex(new BufferAttribute(indices, 1));

    return sRectangle;
};

export default createTexturedRectangle;
